import { combineReducers } from 'redux';
import * as ActionTypes from './inspection.actionTypes';
import * as CostEstimateTypes from '../costEstimate/costEstimate.actionTypes';
import keys from 'lodash/keys';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import mapValues from 'lodash/mapValues';
import generateTempInspection from '../../utils/inspection-utils';
const allIds = (state = [], action) => {
  switch (action.type) {
    case ActionTypes.GENERATE_INSPECTION_ID:
      return [...state, action.id];
    case ActionTypes.CREATE_INSPECTION_SUCCESS: {
      if (action.meta) {
        const tempIndex = state.indexOf(action.meta.tempId);
        if (tempIndex !== -1) {
          return [
            ...state.slice(0, tempIndex),
            ...state.slice(tempIndex + 1),
            action.payload.result,
          ];
        }
      }
      return [...state, action.payload.result];
    }
    case ActionTypes.READ_INSPECTIONS_SUCCESS:
      // Backend returns chunks of data instead of all data now
      // We display only backends data
      return [...keys(action.response.entities.inspection)]
    case ActionTypes.DELETE_INSPECTION_SUCCESS:
    case ActionTypes.DELETE_INSPECTION_FAILURE: {
      const deletedIndex = state.indexOf(action.payload.id);
      if (deletedIndex === -1) {
        return state;
      }
      return [
        ...state.slice(0, deletedIndex),
        ...state.slice(deletedIndex + 1),
      ];
    }
    case ActionTypes.READ_INSPECTION_SUCCESS: {
      const newEntryIndex = state.indexOf(action.response.result);
      if (newEntryIndex > -1) {
        return state;
      }
      return [...state, action.response.result];
    }
    default:
      return state;
  }
};
const availableFilters = (state = {}, action) => {
  if (
    action.response &&
    action.response.entities &&
    action.response.entities.availableFilters
  ) {
    return action.response.entities.availableFilters;
  }
  return state;
};
const byId = (state = {}, action) => {
  let inspection = null;
  const inspectionExists = action.response
    && action.response.entities
    && action.response.entities.inspection
  if (inspectionExists) {
    switch (action.type) {
      case ActionTypes.READ_INSPECTION_SUCCESS:
      case ActionTypes.READ_INSPECTIONS_SUCCESS:
        inspection = mapValues(
          action.response.entities.inspection,
          (val, key) => ({ ...val, serverId: key })
        );
        break;
      case CostEstimateTypes.READ_COSTESTIMATE_SUCCESS:
      case CostEstimateTypes.CREATE_COSTESTIMATE_SUCCESS:
      case CostEstimateTypes.UPDATE_COSTESTIMATE_SUCCESS:
        inspection = action.response.entities.inspection;
        break;
      default:
        return state;
    }
    // Payload is used with redux-offline
  } else if (action.payload) {
    switch (action.type) {
      case ActionTypes.CREATE_INSPECTION_SUCCESS:
        inspection = action.payload.entities.inspection;
        if (action.meta) {
          state[action.meta.tempId].serverId = action.payload.result;
        }
        inspection[action.payload.result].serverId = action.payload.result;
        break;
      case ActionTypes.UPDATE_INSPECTION_SUCCESS:
        inspection = action.payload.entities.inspection;
        break;
      default:
        return state;
    }
  } else if (action.type === ActionTypes.GENERATE_INSPECTION_ID) {
    //TODO: these generated inspections are never deleted
    inspection = generateTempInspection(action.id, action.inspectionType);
  }

  if (!inspection) {
    return state;
  }

  const isDelete = action.response
    && action.response.method
    && action.response.method === 'DELETE';

  if (isDelete) {
    return omit(state, keys(inspection));
  }

  return merge({}, state, inspection);
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case ActionTypes.READ_INSPECTIONS_REQUEST:
      return true;
    case ActionTypes.READ_INSPECTIONS_SUCCESS:
    case ActionTypes.READ_INSPECTIONS_FAILURE:
      return false;
    default:
      return state;
  }
};

const metadata = (state = { metadata: { total: 0, page: 1 } }, action) => {
  switch (action.type) {
    case ActionTypes.READ_INSPECTIONS_REQUEST:
    case ActionTypes.READ_INSPECTIONS_FAILURE:
      return state;
    case ActionTypes.READ_INSPECTIONS_SUCCESS:
      try {
        const { inspections } = action.response.entities;
        const [data] = Object.values(inspections || {});

        // data should have these keys: metadata, inspections, availableFilters
        if (typeof data === 'undefined'
        || !data.hasOwnProperty('metadata')) {
          return state
        }

        const [_metadata] = data['metadata'] || {};

        // some error checking
        if (typeof _metadata !== 'object'
          || !_metadata.hasOwnProperty('total')
          || !_metadata.hasOwnProperty('page')
        ) {
          return state;
        }

        return _metadata
      } catch (error) {
        console.error(error);
        return state
      }
    default:
      return state;
  }
};

const reducer = combineReducers({
  allIds,
  byId,
  availableFilters,
  isFetching,
  metadata,
  //errorMessage,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/inspection/inspection.reducer.js